// components/create/CoverImageModal.js
import React, { useState } from 'react';
import '../../styles/CoverImageModal.scss';

export default function CoverImageModal({ onClose, onSelectImage, eventType }) {
  const [selectedTab, setSelectedTab] = useState('upload');
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = {
          uri: reader.result,
          type: file.type.includes('gif') ? 'gif' : 'image',
          isAnimated: file.type.includes('gif'),
        };
        setUploadedImage(imageData);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSelectUploadedImage = () => {
    if (uploadedImage) {
      onSelectImage(uploadedImage);
    }
  };

  return (
    <div className="cover-image-modal-overlay" onClick={onClose}>
      <div className="cover-image-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Select Cover Image</h2>
          <button className="close-button" onClick={onClose}>
            <i className="icon-close"></i>
          </button>
        </div>

        <div className="modal-tabs">
          <button
            className={`tab-button ${selectedTab === 'upload' ? 'active' : ''}`}
            onClick={() => setSelectedTab('upload')}
          >
            Upload
          </button>
          <button
            className={`tab-button ${selectedTab === 'stock' ? 'active' : ''}`}
            onClick={() => setSelectedTab('stock')}
          >
            Stock Images
          </button>
          <button
            className={`tab-button ${selectedTab === 'giphy' ? 'active' : ''}`}
            onClick={() => setSelectedTab('giphy')}
          >
            GIFs
          </button>
        </div>

        <div className="modal-content">
          {selectedTab === 'upload' && (
            <div className="upload-section">
              <input
                type="file"
                accept="image/*,.gif"
                onChange={handleFileUpload}
                id="file-upload"
                className="file-input"
              />
              <label htmlFor="file-upload" className="upload-area">
                {uploadedImage ? (
                  <img src={uploadedImage.uri} alt="Uploaded" className="uploaded-preview" />
                ) : (
                  <>
                    <i className="icon-cloud-upload"></i>
                    <p>Click to upload or drag and drop</p>
                    <span>PNG, JPG, GIF up to 10MB</span>
                  </>
                )}
              </label>
              
              {uploadedImage && (
                <button
                  className="select-button"
                  onClick={handleSelectUploadedImage}
                >
                  Use This Image
                </button>
              )}
            </div>
          )}

          {selectedTab === 'stock' && (
            <div className="stock-section">
              <p className="coming-soon">Stock images coming soon...</p>
            </div>
          )}

          {selectedTab === 'giphy' && (
            <div className="giphy-section">
              <p className="coming-soon">GIF search coming soon...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}